import React, { useEffect, useRef } from "react";

/**
 * VideoModal - only creates <video> element when open
 * Props:
 * - open, src, poster, title, onClose
 * Keyboard: Esc to close
 */
export default function VideoModal({ open, src = null, poster = null, title = "", onClose = () => {} }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    // auto play when modal opens (best-effort)
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play().catch(() => {});
      }
    }, 50);
    return () => {
      document.removeEventListener("keydown", onKey);
      if (videoRef.current) videoRef.current.pause();
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/85" onClick={onClose} />
      <div className="relative z-10 max-w-4xl w-full bg-black rounded-lg overflow-hidden">
        <div className="flex items-center justify-between p-3">
          <h3 className="text-white font-inria">{title}</h3>
          <button onClick={onClose} className="text-white/80 p-2 rounded bg-white/5">✕</button>
        </div>

        <div className="w-full bg-black">
          <video ref={videoRef} src={src} poster={poster} controls playsInline className="w-full h-[56vw] max-h-[65vh] object-cover bg-black" />
        </div>
      </div>
    </div>
  );
}